import { useState } from 'react';
import { Alert, Button, Form, Image } from 'react-bootstrap';
import icMailSend from '../../assets/img/ic-mail-send.svg';
import { MESSAGE_MAX_LENGTH } from '../../utils/conversations';

// Text-only composer for the REST-only MVP: no attachments/reactions/typing
// indicators. Send is disabled while a request is in flight (no double-submit)
// and while the message is empty or over the backend's character limit.
const ConversationComposer = ({ onSend, sending, error, disabledReason }) => {
    const [text, setText] = useState('');

    const trimmedLength = text.trim().length;
    const isEmpty = trimmedLength === 0;
    const overLimit = text.length > MESSAGE_MAX_LENGTH;
    const canSend = !isEmpty && !overLimit && !sending;

    if (disabledReason) {
        return (
            <div className="conversation-composer conversation-composer--disabled">
                <p className="conversation-composer__disabled-note mb-0">{disabledReason}</p>
            </div>
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!canSend) return;
        const sent = await onSend(text.trim());
        if (sent) setText('');
    };

    return (
        <Form className="conversation-composer" onSubmit={handleSubmit}>
            {error && <Alert variant="danger" className="conversation-composer__error">{error}</Alert>}
            <div className="conversation-composer__row">
                <Form.Control
                    as="textarea"
                    rows={1}
                    placeholder="Write a message…"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    disabled={sending}
                    isInvalid={overLimit}
                    className="conversation-composer__input"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSubmit(e);
                        }
                    }}
                />
                <Button
                    type="submit"
                    variant="primary"
                    className="conversation-composer__send"
                    disabled={!canSend}
                    aria-label="Send message"
                >
                    <Image src={icMailSend} alt="" />
                </Button>
            </div>
            <div className={`conversation-composer__counter${overLimit ? ' conversation-composer__counter--over' : ''}`}>
                {text.length} / {MESSAGE_MAX_LENGTH}
            </div>
        </Form>
    );
};

export default ConversationComposer;
